/**
* @file The book hours insight
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import * as moment from 'moment';
import { LocalisationService } from '../../core/localisation.service';
import { InsightService } from '../../insights/insight.service';
import { InsightLineComponent } from '../insight-line/insight-line.component';
import { InsightProvider } from '../insight-provider';
import { ComponentRegistry } from '../../core/component-registry';
import { ResourceService } from '../../resource.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
/**
 * Insight component that shows the booked hours
 */
var InsightBookedHoursComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InsightBookedHoursComponent, _super);
    /**
     * Constructs an InsightBookedHoursComponent
     * @param configurationsService A service that manages the configuration for components.
     * @param provider A provider that contains extra information such as configuration data.
     */
    function InsightBookedHoursComponent(resourceService, provider, insightService, localisationService, router, alertsService, eventsService) {
        var _this = _super.call(this, resourceService, provider, insightService, localisationService, alertsService, eventsService) || this;
        _this.alertsService = alertsService;
        /**
         * Contains the date of horizon within the view.
         * @private
         */
        _this.horizonDate = moment().startOf('day');
        _this.makeHorizonDateListener(_this.subscriptionPool, router, function (value) {
            _this.horizonDate = value;
            _this.refresh();
        });
        return _this;
    }
    /**
     * Register component by the insight provider
     */
    InsightBookedHoursComponent.register = function () {
        ComponentRegistry.register('insight', 'InsightBookedHoursComponent', InsightBookedHoursComponent);
    };
    Object.defineProperty(InsightBookedHoursComponent.prototype, "start", {
        /**
         * Gets the start of week with respect to startTimeOffset in weeks
         * @readonly
         * @type {Date}
         */
        get: function () {
            var start = this.horizonDate.clone();
            start.add(this.startOffset, 'days');
            return start.toDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightBookedHoursComponent.prototype, "finish", {
        /**
         * Gets finish of week with respect to endTimeOffset in weeks
         * @readonly
         * @type {Date}
         */
        get: function () {
            var date = this.horizonDate.clone();
            date.add(this.finishOffset, 'days');
            var finish = date.toDate();
            if (finish > this.publishedTill) {
                finish = this.publishedTill;
            }
            return finish;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightBookedHoursComponent.prototype, "startOffset", {
        /**
         * Gets the offset of the start in weeks relative to the horizon date.
         * @readonly
         * @private
         * @type {number}
         */
        get: function () {
            var offset = 0;
            if (this.configuration && this.configuration.data && this.configuration.data.startTimeOffset) {
                offset = this.configuration.data.startTimeOffset;
            }
            return offset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightBookedHoursComponent.prototype, "finishOffset", {
        /**
         * Gets the offset of the finish in weeks relative to the horizon date.
         * @readonly
         * @private
         * @type {number}
         */
        get: function () {
            var offset = 0;
            if (this.configuration && this.configuration.data && this.configuration.data.endTimeOffset) {
                offset = this.configuration.data.endTimeOffset;
            }
            return offset;
        },
        enumerable: true,
        configurable: true
    });
    /** Handle for the after items loaded event */
    InsightBookedHoursComponent.prototype.afterItemsLoaded = function () {
        // Start with an empty items array
        var items = [];
        var _loop_1 = function (day) {
            var start = this_1.horizonDate.clone().subtract(day, 'days');
            // Find the item (if exists) with the same date
            var matchedItem = this_1.loadedItems.find(function (loadedItem) { return (moment(loadedItem['date']).diff(start, 'day') === 0); });
            // For some reason numbers are strings here? Why?
            var maximum = (matchedItem) ? parseInt(matchedItem['maximum']) : 0;
            var value = (matchedItem) ? parseInt(matchedItem['value']) : 0;
            // Add item to items and use the, if found, the data from the mached item
            items.push({
                name: this_1.getAxisLabel(start),
                values: [
                    !isNaN(maximum) ? maximum : 0,
                    !isNaN(value) ? value : 0
                ]
            });
        };
        var this_1 = this;
        // First we create the period to make sure we have atleast a correct
        // presentation, e.g. four days with default two values (= 0 and 0).
        for (var day = 4; day >= 0; day -= 1) {
            _loop_1(day);
        }
        // Set the data
        this.setData(items);
    };
    /**
     * Returns a label for the x-axis based on the date it represents.
     * @param date The date from which a string is derived.
     * @returns The day and month.
     */
    InsightBookedHoursComponent.prototype.getAxisLabel = function (date) {
        return date.format(this.localisationService.shortDate.format);
    };
    return InsightBookedHoursComponent;
}(InsightLineComponent));
export { InsightBookedHoursComponent };
